import { z } from 'zod';
import { numericString, optionalNumericString } from './common.schema.js';
export const createListSchema = z.object({
    name: z.string().min(1).max(63),
    campaign_id: z.number(),
    source: z.string().optional(),
});
export const updateListSchema = z.object({
    name: z.string().min(1).max(63).optional(),
    campaign_id: z.number().optional(),
    source: z.string().optional(),
});
export const uploadListSchema = z.object({
    name: z.string().min(1).max(63),
    campaign_id: numericString,
    conflict_policy: z.enum(['skip', 'override']).default('skip'),
    skip_non_us: z
        .string()
        .transform((v) => v === 'true')
        .optional()
        .default('false'),
    override_status: z
        .string()
        .optional()
        .transform((v) => v?.trim() || undefined),
    source: z.string().optional(),
});
export const listListsSchema = z.object({
    campaign_id: numericString.optional(),
    page: optionalNumericString(0),
    page_size: optionalNumericString(50),
    sort_field: z.string().optional(),
    sort_direction: z.enum(['asc', 'desc']).optional().default('desc'),
});
